import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);  // MULTI-TENANT: Dados da company
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await api.get("/auth/me");
        setUser(response.data.user);
        setCompany(response.data.company);  // MULTI-TENANT: Armazenar company
      } catch (error) {
        localStorage.removeItem("token");
        setUser(null);
        setCompany(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", response.data.access_token);
    setUser(response.data.user);
    setCompany(response.data.company);  // MULTI-TENANT: Armazenar company
    return response.data;
  };

  const register = async (name, email, password, companyName = null) => {
    const url = companyName 
      ? `/auth/register?company_name=${encodeURIComponent(companyName)}`
      : "/auth/register";
    const response = await api.post(url, { name, email, password });
    localStorage.setItem("token", response.data.access_token);
    setUser(response.data.user);
    setCompany(response.data.company);  // MULTI-TENANT: Armazenar company
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setCompany(null);
  };

  const changePassword = async (currentPassword, newPassword) => {
    await api.post("/auth/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
  };

  const hasPermission = (permission) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    return user.permissions?.includes(permission);
  };

  const value = {
    user,
    company,  // MULTI-TENANT: Expor company
    loading,
    login,
    register,
    logout,
    changePassword,
    hasPermission,
    checkAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
